/* eslint no-unused-expressions: 0 */
import Velocity from 'velocity-animate';
import 'velocity-animate/velocity.ui.min';
import Swiper from 'swiper';
import * as Utils from '../../utils/utils';
import { gtmDatavizSwitcher, gtmInci, gtmFilters } from '../Seo';

// Contains the big Dataviz for Product Pages
// ===========================================
export default class DataViz {
  constructor() {
    this.node = [...document.querySelectorAll('.js-dataviz')];
    this.activeTab = null;
    this.datavizContent = [];

    if (this.node.length) {
      this.activeContent;

      this.init();
      this.initNavigation();
    }
  }

  init() {
    this.node.forEach((node) => {
      const ingredient = [...node.querySelectorAll('.js-ingredient-list .item-container')];
      const ingredientChunk = [...node.querySelectorAll('.js-ingredient-chunk')];
      const btnSeeMore = node.querySelector('.js-btn-see-more');

      if (btnSeeMore && ingredientChunk.length) {
        this.btnSeeMore(btnSeeMore, ingredientChunk);
      }

      if (ingredientChunk.length) {
        Utils.removeClass(ingredientChunk[0], 'hidden');
      }

      /**
       * Open or close an ingredient detail on the product page.
       *
       * @param {Element} node
      */
      if (ingredient.length) {
        this.showHideIngredients(ingredient);
      }

      /**
       * Switch families handler
       * Display or hide ingredients and bubbles depending on the selected family.
       *
       * @param {Element} node
      */
      this.switchIngredient(node);
    });
  }

  /**
   * Navigation between Inci List and Bubbles.
   *
   * @memberof DataViz
   */
  initNavigation() {
    const tabButtons = [...document.querySelectorAll('.js-product-navigation > button')];

    tabButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        this.activeContent = null;

        // Update navigation
        if (!Utils.hasClass(event.target, 'active')) {
          // Unset attribute and classes
          document.querySelectorAll('button.active')[0].removeAttribute('data-active');
          Utils.removeClass(document.querySelectorAll('button.active')[0], 'active');
          Utils.addClass(event.target, 'active');
          event.target.setAttribute('data-active', true);

          setTimeout(() => {
            this.activeContent = document.querySelector('.js-dataviz.selected');
            this.datavizContent = [...this.activeContent.querySelectorAll('.js-product-content > li')];

            if (this.datavizContent.length > 0) {
              this.datavizContent.forEach(() => {
                if (event.target.dataset.tab === 'ingredients') {
                  this.activeContent.querySelector('[data-content="ingredients"]').classList.add('active');
                  this.activeContent.querySelector('[data-content="bubbles"]').classList.remove('active');
                } else if (event.target.dataset.tab === 'bubbles') {
                  this.activeContent.querySelector('[data-content="bubbles"]').classList.add('active');
                  this.activeContent.querySelector('[data-content="ingredients"]').classList.remove('active');
                }
              });
            }
          }, 50);

          // Send a GTM event
          if (event.isTrusted) {
            gtmDatavizSwitcher(event.target.dataset.display, event.target.dataset.displayVirtual);
          }
        }
      });
    });
  }

  /**
   * Open or close an ingredient detail on the product page.
   *
   * @param {Element} node
   */
  showHideIngredients(ingredient) {
    ingredient.forEach((ing) => {
      const triggerIng = ing.querySelector('.item-link');
      const itemDetails = ing.querySelector('.item-details');

      triggerIng.addEventListener('click', (e) => {
        e.preventDefault();
        const swiperContainer = triggerIng.parentElement.querySelector('.swiper-container');

        if (Utils.hasClass(itemDetails, 'hidden')) {
          this.showIngredient(itemDetails, triggerIng);
        } else {
          this.hideIngredient(itemDetails, triggerIng);
        }

        const swiperIng = new Swiper(swiperContainer, {
          loop: false,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          slidesPerView: 1,
          centeredSlides: true,
          slidesPerColumn: 1,
        });

        if (swiperIng.slides.length <= 1) {
          swiperIng.allowTouchMove = false;
          swiperContainer.querySelector('.swiper-pagination').style.display = 'none';
        }
      });
    });
  }

  /**
   * Switch families handler
   * Display or hide ingredients and bubbles depending on the selected family.
   *
   * @param {Element} node
   */
  switchIngredient(node) {
    const select = node.querySelector('.js-families-filter-mobile select');
    const checkBoxes = [...node.querySelectorAll('.js-families-filter input')];
    const selectOptions = [...select.querySelectorAll('option')];
    const ingredients = [...node.querySelectorAll('.js-ingredient-list li')];
    const ingredientChunk = [...node.querySelectorAll('.js-ingredient-chunk')];
    const btnSeeMore = node.querySelector('.js-btn-see-more');
    // Contains the families list.
    const families = [];

    let dataInput = {};

    if (window.innerWidth >= 767) {
      dataInput = checkBoxes;
    } else {
      dataInput = selectOptions;
    }

    // Push each Input families into an array.
    dataInput.forEach((el) => {
      families.push({
        family: el.dataset.family,
        value: false,
      });
    });

    if (window.innerWidth >= 767) {
      // Handle the click event for our checkboxes.
      checkBoxes.forEach((checkbox) => {
        checkbox.addEventListener('click', (e) => {
          if (node.classList.contains('selected')) {
            const currentView = document.querySelector('.product-tab-btn.active');

            // Send the GTM event
            if (e.isTrusted) {
              gtmFilters(currentView.dataset.display, checkbox.dataset.familyRaw);
            }

            // Hide all ingredients
            ingredients.forEach((i) => Utils.addClass(i, 'hidden'));

            // For each families, only show checked ones.
            families.forEach((item) => {
              if (item.family === checkbox.dataset.family) {
                item.value = checkbox.checked;
              }

              // Toggle a 'checked' class to the parent label element.
              Utils.toggleClass(checkbox.previousSibling.parentElement, 'checked', checkbox.checked);

              // Show ingredients depending on the 'checked' values.
              item.value
                && [].slice.call(node.querySelectorAll(`.js-ingredient-list li.${item.family}`))
                  .forEach((li) => Utils.removeClass(li, 'hidden'));
            });
          }
        });
      });
    } else {
      // Mobile stuff
      select.addEventListener('change', () => {
        if (btnSeeMore) {
          Utils.addClass(btnSeeMore, 'hidden');
        }

        ingredientChunk.forEach((chunk) => Utils.removeClass(chunk, 'hidden'));

        // Hide all ingredients and show only selected
        ingredients.forEach((i) => {
          Utils.addClass(i, 'hidden');
          if (i.dataset.family === select.value) Utils.removeClass(i, 'hidden');
          if (select.value === 'all-family') Utils.removeClass(i, 'hidden');
        });
      });
    }

    // Pre-check them all
    checkBoxes.forEach((checkbox) => {
      this.preCheckFamilies(node, checkbox);
    });
    ingredients.forEach((i) => Utils.removeClass(i, 'hidden'));

    checkBoxes.forEach((checkbox) => {
      checkbox.addEventListener('click', () => {
        if (btnSeeMore) {
          Utils.addClass(btnSeeMore, 'hidden');
        }
        ingredientChunk.forEach((chunk) => Utils.removeClass(chunk, 'hidden'));
      });
    });
  }

  // Pre-chek all families filter
  preCheckFamilies(node, checkbox) {
    if (!node.classList.contains('selected')) {
      Utils.toggleClass(checkbox.previousSibling.parentElement, 'checked', checkbox.checked);
    }
    checkbox.click();
  }

  // Show or hide the "See more" button
  btnSeeMore(btnSeeMore, ingredientChunk) {
    btnSeeMore.addEventListener('click', () => {
      Utils.addClass(btnSeeMore, 'hidden');
      ingredientChunk.forEach((chunk) => Utils.removeClass(chunk, 'hidden'));
    });
  }

  // Show ingredient detail.
  showIngredient(itemDetails, triggerIng) {
    Utils.removeClass(itemDetails, 'hidden');
    Utils.addClass(triggerIng, 'open');

    // Change arrow color
    Utils.removeClass(triggerIng.querySelector('.arrows'), 'arrow-blue');
    Utils.addClass(triggerIng.querySelector('.arrows'), 'arrow-yellow');

    // Change arrow from Down to Up
    Utils.removeClass(triggerIng.querySelector('.arrows > i'), 'icn-small_arrow_down');
    Utils.addClass(triggerIng.querySelector('.arrows > i'), 'icn-small_arrow_up');

    // Finally Open the ingredient details
    Velocity(itemDetails, 'slideDown', {
      duration: 600,
      marginTop: 0,
      marginBottom: 0,
      easing: 'easeInOutCirc',
    });

    // Send a GTM event on click.
    gtmInci(triggerIng.dataset.name);
  }

  // Hide ingredient detail.
  hideIngredient(itemDetails, triggerIng) {
    Utils.addClass(itemDetails, 'hidden');
    Utils.removeClass(triggerIng, 'open');

    // Change arrow color
    Utils.addClass(triggerIng.querySelector('.arrows'), 'arrow-blue');
    Utils.removeClass(triggerIng.querySelector('.arrows'), 'arrow-yellow');

    // Change arrow from Down to Up
    Utils.removeClass(triggerIng.querySelector('.arrows > i'), 'icn-small_arrow_up');
    Utils.addClass(triggerIng.querySelector('.arrows > i'), 'icn-small_arrow_down');

    // Finally Close the ingredient details
    Velocity(itemDetails, 'slideUp', {
      duration: 600,
      marginTop: 0,
      marginBottom: 0,
      easing: 'easeInOutCirc',
    });
  }
}
